export type PromoBadgeStrapi = {
  text?: string | null;
  showUntil?: string | null;
};

export const isPromoBadgeExpired = (showUntil: string) =>
  Date.now() >= new Date(showUntil).getTime();

export const getActivePromoBadge = (
  badge?: PromoBadgeStrapi | null
): PromoBadgeStrapi | null => {
  if (!badge?.showUntil || isPromoBadgeExpired(badge.showUntil)) return null;

  return badge;
};
